import React, { useEffect, useState } from 'react'
import axios from '../../../data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import ButtonSelect from '~/Common-Objects/UI/Forms/ButtonSelect/ButtonSelect'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'

export default function TagSelect({
    selected = [],
    tagType = 0,
    explainer = '',
    usePortal,
    dropDownStyle,
    add = () => {},
    remove = () => {}
}) {
    const [tags, setTags] = useState(null)
    const [addingText, setAddingText] = useState('')
    const [error, setError] = useState('')

    const getTags = async () => {
        setTags((await axios.get('/tags?tagType=' + tagType)).data)
    }

    const selectTag = (e) => {
        const id = parseInt(e.currentTarget.name)
        const arr = [...selected]
        const index = arr.findIndex((t) => t == id)
        if (index > -1) remove(id)
        else add(id)
    }

    const saveTag = async () => {
        if (!addingText || !addingText.trim()) return
        setError('')
        try {
            const res = await axios.post('/tags', {
                tagType,
                tagName: addingText
            })
            await getTags()
            add(res.data.find((t) => t.tagName === addingText).id)
            setAddingText('')
        } catch (e) {
            setError(e.data.error)
        }
    }

    useEffect(() => {
        getTags()
    }, [tagType])

    useEffect(() => {
        setError('')
    }, [addingText])

    if (!tags) return <LoadingIcons />

    let headerText = 'Select Tags'
    if (selected.length) {
        headerText = (
            <div>
                {selected.map((id) => {
                    const tag = tags.find((t) => t.id === id)
                    if (!tag) return ''
                    return (
                        <SquareChip key={id} className='square-chip-tag mar-r10'>
                            {tag.tagName}
                        </SquareChip>
                    )
                })}
            </div>
        )
    }

    return (
        <>
            <ButtonSelect
                headerText={headerText}
                buttonStyle={{ fontWeight: 'normal' }}
                usePortal={usePortal}
                dropdownStyle={dropDownStyle}
            >
                <div className='quickFlex' style={{ padding: '10px 10px 0 10px' }}>
                    <TextInput
                        outerStyle={{ flexGrow: 1 }}
                        error={error}
                        outerClassName='mar-r10'
                        placeholder='New Tag Name'
                        value={addingText}
                        onEnterPress={saveTag}
                        onChange={(e) => setAddingText(e.currentTarget.value)}
                    />
                    <Button
                        onClick={saveTag}
                        disabled={!addingText.trim()}
                        className='button-md button-primary'
                        style={{ flexShrink: 0 }}
                    >
                        Add New
                    </Button>
                </div>
                <ul>
                    {tags.map((tag) => {
                        return (
                            <li key={tag.id} className='quickFlex' style={{ justifyContent: 'space-between' }}>
                                <CheckBox
                                    outerClassName='full-width'
                                    name={tag.id}
                                    onChange={selectTag}
                                    checked={selected.indexOf(tag.id) > -1}
                                >
                                    {tag.tagName}
                                </CheckBox>
                            </li>
                        )
                    })}
                </ul>
            </ButtonSelect>
            {!!explainer && <div className='txtInput_explainer'>{explainer}</div>}
        </>
    )
}
